import { MarketTabT, OrderType, OrdersTabT, OrdersViewTabs, TranslateOptionsT } from 'types';

export const getOpenOrdersStatuses = (_t: Function) => {
  return {
    new: _t('Open', 'VIEW_ORDERS.ORDER_STATUS_OPEN'),
    not_filled: _t('Open', 'VIEW_ORDERS.ORDER_STATUS_OPEN'),
    partially_filled: _t('Partially filled', 'VIEW_ORDERS.ORDER_STATUS_PARTIALLY_FILLED'),
    error: _t('Rejected', 'VIEW_ORDERS.ORDER_STATUS_REJECTED'),
    rejected: _t('Rejected', 'VIEW_ORDERS.ORDER_STATUS_REJECTED'),
    settlement: _t('Pending Settlement', 'VIEW_ORDERS.ORDER_STATUS_PENDING_SETTLEMENT'),
    pending_settlement: _t('Pending Settlement', 'VIEW_ORDERS.ORDER_STATUS_PENDING_SETTLEMENT'),
    pending_review: _t('Pending Review', 'VIEW_ORDERS.ORDER_STATUS_PENDING_REVIEW'),
  };
};

export const getClosedOrdersStatuses = (_t: Function) => {
  return {
    completely_filled: _t('Filled', 'VIEW_ORDERS.ORDER_STATUS_FILLED'),
    canceled: _t('Cancelled', 'VIEW_ORDERS.ORDER_STATUS_CANCELLED'),
    reclaimed: _t('Cancelled', 'VIEW_ORDERS.ORDER_STATUS_CANCELLED'),
    error: _t('Cancelled', 'VIEW_ORDERS.ORDER_STATUS_CANCELLED'),
  };
};

export const getNotification = (message: string, _t: Function) => {
  const messages = {
    createdOrderSuccess: _t('Order submitted!', 'NOTIFICATIONS.CREATE_ORDER_SUCCESS'),
    createdOrderError: _t('Failed to submit order!', 'NOTIFICATIONS.CREATE_ORDER_ERROR'),
    cancelOrderSuccess: _t('Order canceled!', 'NOTIFICATIONS.CANCEL_ORDER_SUCCESS'),
    cancelOrderError: _t('Failed to cancel order!', 'NOTIFICATIONS.CANCEL_ORDER_ERROR'),
    reclaimOrderSuccess: _t('The order was refunded!', 'NOTIFICATIONS.RECLAIM_ORDER_SUCCESS'),
    reclaimOrderError: _t('The order was refunded with error!', 'NOTIFICATIONS.RECLAIM_ORDER_ERROR'),
    pleaseConnectWallet: _t('Please connect your wallet', 'NOTIFICATIONS.CONNECT_WALLET'),
    tryAgain: _t('We ran into a problem, please try again', 'NOTIFICATIONS.TRY_AGAIN'),
  };

  return messages[message];
};

// Tabs
export const getTradeTabOptions = (_t: Function): MarketTabT[] => {
  return [
    {
      name: _t('Market', 'GENERAL.MARKET'),
      value: OrderType.Market,
    },
    {
      name: _t('Limit', 'GENERAL.LIMIT'),
      value: OrderType.Limit,
    },
  ];
};

export const getOrdersTabOptions = (_t: Function): OrdersTabT[] => {
  return [
    {
      name: _t('Orders', 'VIEW_ORDERS.TAB_ORDERS'),
      value: OrdersViewTabs.OpenOrders,
    },
    {
      name: _t('Order History', 'VIEW_ORDERS.TAB_ORDERS_HISTORY'),
      value: OrdersViewTabs.OrderHistory,
    },
  ];
};

export const getLimitPriceValidationMessages = (_t: Function) => {
  return {
    minPrice: _t('Price must not be lower than', 'VALIDATION.PRICE_NOT_LOWER'),
    maxPrice: _t('Price must not be higher than', 'VALIDATION.PRICE_NOT_HIGHER'),
    walletNotConnected: _t('Please connect your wallet', 'NOTIFICATIONS.CONNECT_WALLET'),
    default: '',
  };
};

export const getOrderAmountValidationMessages = (_t: Function) => {
  return {
    walletNotConnected: _t('Please connect your wallet', 'VALIDATION.CONNECT_WALLET'),
    walletBalanceExceeds: _t('Insufficient funds for trade', 'VALIDATION.INSUFFICIENT_FUNDS'),
    minAmountAxceeds: _t('Amount must not be less than', 'VALIDATION.AMOUNT_NOT_LESS'),
    maxAmountAxceeds: _t('Amount must not be greater than', 'VALIDATION.AMOUNT_NOT_GREATER'),
    insufficientNativeToken: _t(
      'Insufficient network fee. Add more AVAX to your wallet',
      'VALIDATION.INSUFFICIENT_FEE'
    ),
    default: '',
  };
};

export const countryBlacklistTerms: {[key in 'linkLabel' | 'warningText'] : TranslateOptionsT} = {
  linkLabel: { 
    defaultTerm: 'Terms of Use',
    key: 'GENERAL.TERMS_OF_SERVICE',
  },
  warningText: { 
    defaultTerm: 'Cables is unavailable in your country and you are prohibited from accessing the service. For more information, please read our ',
    key: 'COUNTRY_BLACKLIST.WARNING_TITILE',
  },
}